import { Api } from '@/api';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner';
import { useCurrentWorkflowStore } from '@/stores/workflow/currentWorkflow';
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { toast } from 'vue-sonner';

export const useWorkflowDetail = () => {
  const workflowDetailStore = useCurrentWorkflowStore();
  const route = useRoute();
  const router = useRouter();
  const showDeleteModal = ref(false);
  const loadingSpinner = useLoadingSpinnerStore();

  onMounted(async () => {
    await workflowDetailStore.loadWorkflow(+route.params.id);
  });

  const deleteWorkflow = async () => {
    const response = await Api.Workflows.destroyWorkflow(+route.params.id);
    loadingSpinner.hideLocalLoadingSpinner();
    if (response.status === 'success') {
      const description = 'Your workflow was successfully deleted.';
      toast.success('Workflow Deleted', { description });
      showDeleteModal.value = false;
      router.push({ name: 'CandidateWorkflow' });
    } else {
      const description = `${response.messages.join(', ')}.`;
      toast.error('Workflow Delete Error', { description });
    }
  };

  const hasScheduledActions = computed(() =>
    workflowDetailStore.currentWorkflow.workflow_actions.some(x => x.invocation === 'scheduled')
  );

  const deleteModal = computed(() => {
    const pending = workflowDetailStore.currentWorkflow.workflow_actions.reduce(
      (prev, action) => prev + action.pending_scheduled_instance_count,
      0
    );
    if (pending === 0) {
      return {
        title: 'Delete Workflow',
        description: 'Are you sure you want to permanently delete this Workflow?',
      };
    } else {
      return {
        title: '⚠️ ATTENTION',
        description: `Deleting this workflow will CANCEL ${pending} scheduled action${pending > 1 ? 's' : ''}. Are you sure you want to permanently delete this workflow?`,
      };
    }
  });

  return {
    showWorkflowDetails: computed(() => workflowDetailStore.isLoaded),
    showLoading: computed(() => !workflowDetailStore.isLoaded),
    showDeleteModal,
    hasScheduledActions,
    deleteModal,
    displayDeleteModal: () => (showDeleteModal.value = true),
    hideDeleteModal: () => (showDeleteModal.value = false),
    deleteWorkflow,
  };
};
